export enum RegionalizacaoEnum {
  BR = 1,
  CO = 2,
  PE = 3,
  EC = 4,
}

export enum RegionalizacaoCodigoEnum {
  Brasil = "BR",
  Colombia = "CO",
  Peru = "PE",
  Equador = "EC",
}
